import styled from 'styled-components';
import { NavLink, Link } from 'react-router-dom';
export const Header = styled.header`
  display: flex;
  flex-direction: column;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  width: 7.5%;
  flex: 1;
  height: 100vh;
  background-color: #4e6e29;
  z-index: 20;
`;
export const HeaderContainer = styled.div``;
export const HeaderLogoImg = styled.img``;
export const HeaderNav = styled.nav``;

export const Label = styled.span`
  display: none;
  background-color: #000;
  position: absolute;
  color: #ffffff;
  font-size: 1rem;
  padding: 8px 10px;
  top: 1.5rem;
  right: 10.5rem;
  border-radius: 5px;
  &::after {
    content: '';
    position: absolute;
    right: -5px;
    top: 7px;
    width: 0px;
    border: 10px 10px 10px 10px;
    border-left: 5px solid #000;
    height: 0px;
    border-bottom: 7px solid transparent;
    border-top: 7px solid transparent;
    z-index: 0;
  }
`;

export const HeaderNavLink = styled(NavLink)`
  font-size: 2rem;
  color: #e6e6e6;
  position: relative;
  padding: 0.8em;
  font-size: 2rem;
  line-height: 1.3;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  &:hover {
    background: #000;
  }
  &:hover ${Label} {
    display: block;
  }
  &.active {
    background: #000;
  }
`;
export const HeaderLogo = styled.div`
  width: 50%;
  margin: 30px auto;
`;
export const HeaderLogoLink = styled(Link)``;
